<template>
  <Message severity="error" :closable="false" data-testid="load-error">
    <div class="flex items-center justify-between gap-3 flex-wrap w-full">
      <span>{{ text }}</span>
      <Button
        label="Try again"
        icon="pi pi-refresh"
        size="small"
        severity="danger"
        outlined
        :loading="retrying"
        data-testid="btn-load-retry"
        @click="emit('retry')"
      />
    </div>
  </Message>
</template>

<script setup lang="ts">
import { loadErrorMessage } from '@/utils/billingLoadError';

/**
 * Shown in place of a list that failed to load, so a failed request never
 * reads as "nothing here yet" (which leads people to re-create data or report
 * it missing). Says what failed, in plain words, and offers Retry.
 */
const props = defineProps<{
  /** What failed to load, e.g. "the guardians". */
  what: string;
  /** The error from the query, used for network / permission wording. */
  error?: unknown;
  /** Spinner on the button while a retry is in flight. */
  retrying?: boolean;
}>();

const emit = defineEmits<{ retry: [] }>();

const text = computed(() => loadErrorMessage(props.what, props.error));
</script>
